import EmConstrucao from "./EmConstrucao";

function Solucoes() {
  return (
        <EmConstrucao />
    )
}

export default Solucoes;
